// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * ObjectStore entry attributes
 */
export enum ECpmCObjectStoreEntryAttributesProxyApiEnum {
    NONE = 0,
    INTERNAL = 1 << 0
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCObjectStoreEntryAttributesProxyApiEnum = Object.fromEntries(
    Object.entries(ECpmCObjectStoreEntryAttributesProxyApiEnum)
        .filter((x) => !x[0].toString().toUpperCase().startsWith("MASK_"))
        .filter((x) => !x[1].toString().toUpperCase().startsWith("MASK_"))
        .map(([key, value]) => [
            value,
            key as unknown as ECpmCObjectStoreEntryAttributesProxyApiEnum
        ])
);


// ===============================================================
// ===============================================================

/**
 * ObjectStore entry type status
 */
export enum ECpmCObjectStoreEntryProxyTypeApiEnum {
    STRING = 'STRING',
    INTEGER = 'INTEGER',
    FLOAT = 'FLOAT',
    BOOLEAN = 'BOOLEAN',
    STRING_ARRAY = 'STRING_ARRAY',
    INTEGER_ARRAY = 'INTEGER_ARRAY',
    FLOAT_ARRAY = 'FLOAT_ARRAY',
    BOOLEAN_ARRAY = 'BOOLEAN_ARRAY',
    OBJECT = 'OBJECT',
    OBJECT_ARRAY = 'OBJECT_ARRAY'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCObjectStoreEntryProxyTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCObjectStoreEntryProxyTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCObjectStoreEntryProxyTypeApiEnum
        ])
);

